<template>
  <div class="container">
    <Donnees_non_disponible :ToutesLesCondamnation="ToutesLesCondamnation" />
    <div class="alert alert-warning" role="alert">
      <!-- Tous les autres frames -->
      <div
        v-if="type_condamnation == 'alimentation'"
        class="frame frame-default frame-type-textmedia frame-layout-0"
      >
        <div class="ce-textpic ce-left ce-above">
          <div class="ce-bodytext">
            <p>
              Vous pouvez consulter ici la
              <strong
                >liste des condamnations des établissements alimentaires</strong
              >. Celles-ci découlent des poursuites intentées au cours de la
              surveillance exercée par le gouvernement du Québec.
            </p>
          </div>
        </div>
      </div>
      <div
        v-if="type_condamnation == 'animal'"
        class="frame frame-default frame-type-textmedia frame-layout-0"
      >
        <div class="ce-textpic ce-left ce-above">
          <div class="ce-bodytext">
            <p>
              Vous pouvez consulter ici la
              <strong
                >liste des condamnations concernant le bien-être des
                animaux</strong
              >. Celles-ci découlent des poursuites intentées au cours de la
              surveillance exercée par le gouvernement du Québec.
            </p>
          </div>
        </div>
      </div>
    </div>
    <p>
      La liste présente les condamnations diffusées au cours des
      <strong>24 derniers mois</strong>. Une mise à jour est effectuée
      régulièrement.
    </p>
    <p>
      Par défaut, les données s’affichent selon la date du jugement. Les
      établissements ou personnes apparaissent par ordre alphabétique.
    </p>
    <p v-if="type_condamnation == 'alimentation'">
      Pour en savoir plus sur les condamnations, visitez la page
      <a
        target="_blank"
        href="https://www.quebec.ca/sante/alimentation/condamnations-etablissements-alimentaires/inspection-etablissements-alimentaires"
        >Surveillance et inspection des établissements alimentaires</a
      >.
    </p>
    <p v-if="type_condamnation == 'animal'">
      Pour en savoir plus sur les condamnations, visitez la page
      <a
        target="_blank"
        href="https://www.quebec.ca/agriculture-environnement-et-ressources-naturelles/sante-animale/securite-bien-etre-animaux/inspection-saisie-animaux"
        >Inspection et saisie d’animaux</a
      >.
    </p>

    <p>
      Pour télécharger la liste complète au format CSV, visitez le site
      <a
        target="_blank"
        href="https://www.donneesquebec.ca/recherche/dataset/condamnations-des-etablissements-alimentaires-et-condamnations-concernant-le-bien-etre-des-anim/resource/40105615-3abf-414b-bcba-182e8f2c5eb2"
        >Données Québec</a
      >.
    </p>

    <Loading v-if="isFetching" />

    <RechercheCond @filtreRecherche="filtreRecherche" />
    <div class="flex-container">
      <div class="col-filtres">
        <div class="bg-filtres">
          <h4>Filtres</h4>
          <Reset @reset="reset" />
          <FiltreCond
            @filtreDate1="filtreDate1"
            @filtreDate2="filtreDate2"
            @filtreDate3="filtreDate3"
            @filtreDate4="filtreDate4"
            @filtrePoursuivant="filtrePoursuivant"
            :type_condamnation="type_condamnation"
            @filtreType="filtreType"
            @filtreTypeChoix="filtreTypeChoix"
          />
        </div>
      </div>
      <div class="col-afficher-cond" id="top-list">
        <div class="nombres-containter">
          <NombreResultatAfficher
            :condamnations="condamnations"
            :nbrResultats="nbrResultats"
            :isFetching="isFetching"
            ref="focusTargetCondTotal"
          />
          <NombrePageCourante
            :pageCourante="pageCourante"
            :nbrPages="nbrPages"
            :nbrResultats="nbrResultats"
            :nbrResultatsDernierePage="nbrResultatsDernierePage"
          />
        </div>
        <ListeFiltres @resetFiltre="resetFiltre" :filtres="filtres" />
        <NombreResultatsParPage
          :nbrResultats="nbrResultats"
          @changerNombreResultatsParPage="changerNombreResultatsParPage"
        />
        <Condamnations
          :isFetching="isFetching"
          :condamnations="condamnations"
          :pageCourante="pageCourante"
          :filtres="filtres"
          :nbrResultats="nbrResultats"
        />
        <div class="pagination" role="navigation">
          <PaginationPrincipal
            :condamnations="condamnations"
            :pageCourante="pageCourante"
            :nbrResultats="nbrResultats"
            :nbrPages="nbrPages"
            @nextPage="pageChangeHandle('next')"
            @previousPage="pageChangeHandle('previous')"
            @loadPage="pageChangeHandle"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Donnees_non_disponible from './components/Donnees_non_disponible';
import Loading from './components/Loading';
import FiltreCond from './components/Filtre_condamnation';
import ListeFiltres from './components/Liste_filtres';
import RechercheCond from './components/Recherche_condamnation';
import Reset from './components/Reset_bouton';
import PaginationPrincipal from './components/Pagination_principal.vue';
import Condamnations from './components/Condamnations';
import NombreResultatAfficher from './components/Nombre_resultat_afficher';
import NombreResultatsParPage from './components/Nombre_resultat_par_page';
import NombrePageCourante from './components/Nombre_page_courante';

export default {
  name: 'App',
  components: {
    Donnees_non_disponible,
    Loading,
    PaginationPrincipal,
    Condamnations,
    NombreResultatAfficher,
    NombreResultatsParPage,
    FiltreCond,
    ListeFiltres,
    RechercheCond,
    Reset,
    NombrePageCourante,
  },
  data() {
    return {
      type_condamnation: String,
      ToutesLesCondamnation: [],
      condamnations: [],
      ToutesLesCondamnationAnimal: [],
      nbrResultats: 10,
      nbrResultatsDernierePage: 0,
      pageCourante: 1,
      nbrPages: 0,
      bottom: false,
      isFetching: false,
      filtres: {
        typeCond: 'all',
        ville: '',
        etablissement: '',
        typeCondChoix: '',
        date1: 1346318800000,
        date2: new Date().getTime(),
        date3: 1346318800000,
        date4: new Date().getTime(),
        date1Formatted: '',
        date2Formatted: '',
        date3Formatted: '',
        date4Formatted: '',
        poursuivant: 'all',
      },
    };
  },
  watch: {
    filtres: {
      handler: function () {
        this.filtreLesCondamnation();
      },
      deep: true,
    },
    condamnation(condamnation) {
      if (this.nbrResultats >= condamnation.length) {
        this.nbrResultats = condamnation.length;
      }
    },
  },
  methods: {
    async pageChangeHandle(value) {
      switch (value) {
        case 'next':
          this.pageCourante += 1;
          break;
        case 'previous':
          this.pageCourante -= 1;
          break;
        default:
          this.pageCourante = value;
      }
    },
    changerNombreResultatsParPage(nombreResultatsParPage) {
      this.nbrResultats = parseInt(nombreResultatsParPage);
      this.pageCourante = 1;
      this.filtreLesCondamnation();
    },
    filtreDate1(date1, date1Formatted) {
      this.filtres.date1 = date1;
      this.filtres.date1Formatted = new Date(date1Formatted).toLocaleDateString(
        'fr-FR',
        { timeZone: 'UTC' }
      );
      //ajout pour la pagination
      this.pageCourante = 1;
    },
    filtreDate2(date2, date2Formatted) {
      this.filtres.date2 = date2;
      this.filtres.date2Formatted = new Date(date2Formatted).toLocaleDateString(
        'fr-FR',
        { timeZone: 'UTC' }
      );
      //ajout pour la pagination
      this.pageCourante = 1;
    },
    filtreDate3(date3, date3Formatted) {
      this.filtres.date3 = date3;
      this.filtres.date3Formatted = new Date(date3Formatted).toLocaleDateString(
        'fr-FR',
        { timeZone: 'UTC' }
      );
      //ajout pour la pagination
      this.pageCourante = 1;
    },
    filtreDate4(date4, date4Formatted) {
      this.filtres.date4 = date4;
      this.filtres.date4Formatted = new Date(date4Formatted).toLocaleDateString(
        'fr-FR',
        { timeZone: 'UTC' }
      );
      //ajout pour la pagination
      this.pageCourante = 1;
    },
    filtrePoursuivant(poursuivant) {
      this.filtres.poursuivant = poursuivant;
      this.pageCourante = 1;
    },
    filtreType(leType) {
      this.filtres.typeCond = leType;
      //ajout pour la pagination
      this.pageCourante = 1;
    },
    filtreTypeChoix(typeCond) {
      this.filtres.typeCondChoix = typeCond;
      //ajout pour la pagination
      this.pageCourante = 1;
    },
    filtreRecherche(ville, etablissement) {
      this.filtres.ville = ville;
      this.filtres.etablissement = etablissement;
      //ajout pour la pagination
      this.pageCourante = 1;
    },
    filtreLesCondamnation() {
      //this.nbrResultats=10;
      let dataCondamnations;
      if (
        this.filtres.typeCondChoix == 'animal' ||
        this.type_condamnation == 'animal'
      ) {
        dataCondamnations = this.ToutesLesCondamnationAnimal;
        this.type_condamnation = 'animal';
        window.history.replaceState(null, null, '?type=animal');
      }
      if (
        this.filtres.typeCondChoix == 'alimentation' ||
        this.type_condamnation == 'alimentation'
      ) {
        dataCondamnations = this.ToutesLesCondamnation;
        this.type_condamnation = 'alimentation';
        window.history.replaceState(null, null, '?type=alimentation');
      }

      this.condamnations = dataCondamnations.filter((result) => {
        if (this.filtres.ville != '' && this.filtres.etablissement == '') {
          let villeUpperCase = this.filtres.ville
            .toUpperCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
          let posVirgule =
            result.Adresse_lieu_infraction.toString().indexOf(',');
          let posDernierEspaceAvantVirgule =
            result.Adresse_lieu_infraction.toString().lastIndexOf(
              ' ',
              posVirgule
            );
          if (
            result.Adresse_lieu_infraction.toString().includes(
              villeUpperCase,
              posDernierEspaceAvantVirgule
            ) == true
          ) {
            let datePublication = result.Date_publication.substring(0, 10);
            let datePublicationFormat = new Date(
              datePublication.replace(/-/g, '/')
            ).getTime();
            let dateInfraction = result.Date_infraction.substring(0, 10);
            let dateInfractionFormat = new Date(
              dateInfraction.replace(/-/g, '/')
            ).getTime();
            if (
              datePublicationFormat >= this.filtres.date1 &&
              datePublicationFormat <= this.filtres.date2 &&
              dateInfractionFormat >= this.filtres.date3 &&
              dateInfractionFormat <= this.filtres.date4
            ) {
              if (this.filtres.typeCond == 'all') {
                if (this.filtres.poursuivant == 'all') {
                  return result;
                } else {
                  if (
                    result.SOC_DESC_POURS.toString() == this.filtres.poursuivant
                  ) {
                    return result;
                  }
                }
              } else {
                if (
                  result.SOC_CD_REGRP_TYP_ENTT.toString() ==
                  this.filtres.typeCond
                ) {
                  if (this.filtres.poursuivant == 'all') {
                    return result;
                  } else {
                    if (
                      result.SOC_DESC_POURS.toString() ==
                      this.filtres.poursuivant
                    ) {
                      return result;
                    }
                  }
                }
              }
            }
          }
        }

        if (this.filtres.ville == '' && this.filtres.etablissement == '') {
          let datePublication = result.Date_publication.substring(0, 10);
          let datePublicationFormat = new Date(
            datePublication.replace(/-/g, '/')
          ).getTime();
          let dateInfraction = result.Date_infraction.substring(0, 10);
          let dateInfractionFormat = new Date(
            dateInfraction.replace(/-/g, '/')
          ).getTime();
          if (
            datePublicationFormat >= this.filtres.date1 &&
            datePublicationFormat <= this.filtres.date2 &&
            dateInfractionFormat >= this.filtres.date3 &&
            dateInfractionFormat <= this.filtres.date4
          ) {
            if (this.filtres.typeCond == 'all') {
              if (this.filtres.poursuivant == 'all') {
                return result;
              } else {
                if (
                  result.SOC_DESC_POURS.toString() == this.filtres.poursuivant
                ) {
                  return result;
                }
              }
            } else {
              if (
                result.SOC_CD_REGRP_TYP_ENTT.toString() == this.filtres.typeCond
              ) {
                if (this.filtres.poursuivant == 'all') {
                  return result;
                } else {
                  if (
                    result.SOC_DESC_POURS.toString() == this.filtres.poursuivant
                  ) {
                    return result;
                  }
                }
              }
            }
          }
        }

        if (this.filtres.etablissement != '' && this.filtres.ville == '') {
          let etablissementUpperCase = this.filtres.etablissement
            .toUpperCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
          if (
            result.Raison_sociale?.toString().includes(
              etablissementUpperCase
            ) == true ||
            result.Nom_exploitant?.toString().includes(
              etablissementUpperCase
            ) == true
          ) {
            let datePublication = result.Date_publication.substring(0, 10);
            let datePublicationFormat = new Date(
              datePublication.replace(/-/g, '/')
            ).getTime();
            let dateInfraction = result.Date_infraction.substring(0, 10);
            let dateInfractionFormat = new Date(
              dateInfraction.replace(/-/g, '/')
            ).getTime();
            if (
              datePublicationFormat >= this.filtres.date1 &&
              datePublicationFormat <= this.filtres.date2 &&
              dateInfractionFormat >= this.filtres.date3 &&
              dateInfractionFormat <= this.filtres.date4
            ) {
              if (this.filtres.typeCond == 'all') {
                if (this.filtres.poursuivant == 'all') {
                  return result;
                } else {
                  if (
                    result.SOC_DESC_POURS.toString() == this.filtres.poursuivant
                  ) {
                    return result;
                  }
                }
              } else {
                if (
                  result.SOC_CD_REGRP_TYP_ENTT.toString() ==
                  this.filtres.typeCond
                ) {
                  if (this.filtres.poursuivant == 'all') {
                    return result;
                  } else {
                    if (
                      result.SOC_DESC_POURS.toString() ==
                      this.filtres.poursuivant
                    ) {
                      return result;
                    }
                  }
                }
              }
            }
          }
        }

        if (this.filtres.etablissement != '' && this.filtres.ville != '') {
          let etablissementUpperCase = this.filtres.etablissement
            .toUpperCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
          let villeUpperCase = this.filtres.ville
            .toUpperCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
          let posVirgule =
            result.Adresse_lieu_infraction.toString().indexOf(',');
          let posDernierEspaceAvantVirgule =
            result.Adresse_lieu_infraction.toString().lastIndexOf(
              ' ',
              posVirgule
            );
          if (
            (result.Raison_sociale?.toString().includes(
              etablissementUpperCase
            ) == true ||
              result.Nom_exploitant?.toString().includes(
                etablissementUpperCase
              ) == true) &&
            result.Adresse_lieu_infraction.toString().includes(
              villeUpperCase,
              posDernierEspaceAvantVirgule
            ) == true
          ) {
            let datePublication = result.Date_publication.substring(0, 10);
            let datePublicationFormat = new Date(
              datePublication.replace(/-/g, '/')
            ).getTime();
            let dateInfraction = result.Date_infraction.substring(0, 10);
            let dateInfractionFormat = new Date(
              dateInfraction.replace(/-/g, '/')
            ).getTime();
            if (
              datePublicationFormat >= this.filtres.date1 &&
              datePublicationFormat <= this.filtres.date2 &&
              dateInfractionFormat >= this.filtres.date3 &&
              dateInfractionFormat <= this.filtres.date4
            ) {
              if (this.filtres.typeCond == 'all') {
                if (this.filtres.poursuivant == 'all') {
                  return result;
                } else {
                  if (
                    result.SOC_DESC_POURS.toString() == this.filtres.poursuivant
                  ) {
                    return result;
                  }
                }
              } else {
                if (
                  result.SOC_CD_REGRP_TYP_ENTT.toString() ==
                  this.filtres.typeCond
                ) {
                  if (this.filtres.poursuivant == 'all') {
                    return result;
                  } else {
                    if (
                      result.SOC_DESC_POURS.toString() ==
                      this.filtres.poursuivant
                    ) {
                      return result;
                    }
                  }
                }
              }
            }
          }
        }
      });

      //ajout pour la pagination
      this.nbrPages = Math.ceil(this.condamnations.length / this.nbrResultats);

      // Calculons le nombre de résultats dans la dernière page
      this.calculerNbrResultatsDernierePage();
    },
    changeNbrResultat() {
      let nbrTotal = this.condamnation.length;
      let nbrRestants = nbrTotal - this.nbrResultats - 20;
      if (nbrTotal >= this.nbrResultats) {
        this.nbrResultats = this.nbrResultats + 20;
      }
      if (nbrRestants <= 0) {
        this.nbrResultats = nbrTotal;
      }
    },
    calculerNbrResultatsDernierePage() {
      // Calculons le nombre de résultats à la dernière page
      // Mettons qu'on a 362 résultats, 37 pages et on veut 10 résultats par page
      // Donc : 36 pages de 10 résultats et une 37e page avec 2 résultats
      // Formule : (Nombre de condamnations) - ((nombre de pages - 1) * nombre de résultats par page)
      // 362 - ((37 - 1) * 10)
      // 362 - ((36) * 10)
      // 362 - 360
      // = 2
      // Donc 2 résultats à la dernière page
      this.nbrResultatsDernierePage =
        this.condamnations.length - (this.nbrPages - 1) * this.nbrResultats;
    },
    reset() {
      // Reset data
      this.filtres.etablissement = '';
      this.filtres.ville = '';
      this.filtres.typeCond = 'all';
      this.filtres.poursuivant = 'all';
      this.filtres.date1 = 1346318800000;
      this.filtres.date2 = new Date().getTime();
      this.filtres.date3 = 1346318800000;
      this.filtres.date4 = new Date().getTime();
      this.filtres.date1Formatted = '';
      this.filtres.date2Formatted = '';
      this.filtres.date3Formatted = '';
      this.filtres.date4Formatted = '';

      // Reset in DOM
      if (document.getElementById('type_entreprise-aliment')) {
        document.getElementById('type_entreprise-aliment').value = 'all';
      }
      if (document.getElementById('type_entreprise-animal')) {
        document.getElementById('type_entreprise-animal').value = 'all';
      }
      document.getElementById('filtre_par_poursuivant').value = 'all';
      document.getElementById('recherche_par_ville').value = '';
      document.getElementById('recherche_par_etablissement').value = '';
      document.getElementById('publication-from').value = '';
      document.getElementById('publication-to').value = '';
      document.getElementById('infraction-from').value = '';
      document.getElementById('infraction-to').value = '';
    },
    resetFiltre(filtreReset) {
      if (filtreReset == 'ville') {
        this.filtres.ville = '';
        document.getElementById('recherche_par_ville').value = '';
      }
      if (filtreReset == 'etablissement') {
        this.filtres.etablissement = '';
        document.getElementById('recherche_par_etablissement').value = '';
      }
      if (filtreReset == 'date1') {
        this.filtres.date1 = 1346318800000;
        this.filtres.date1Formatted = '';
        document.getElementById('publication-from').value = '';
      }
      if (filtreReset == 'date2') {
        this.filtres.date2 = new Date().getTime();
        this.filtres.date2Formatted = '';
        document.getElementById('publication-to').value = '';
      }
      if (filtreReset == 'date3') {
        this.filtres.date3 = 1346318800000;
        this.filtres.date3Formatted = '';
        document.getElementById('infraction-from').value = '';
      }
      if (filtreReset == 'date4') {
        this.filtres.date4 = new Date().getTime();
        this.filtres.date4Formatted = '';
        document.getElementById('infraction-to').value = '';
      }
      if (filtreReset == 'typeCond') {
        this.filtres.typeCond = 'all';
        if (document.getElementById('tous-bien-etre-animal')) {
          document.getElementById('type_entreprise-animal').selectedIndex = 0;
        }
        if (document.getElementById('tous-alimentation')) {
          document.getElementById('type_entreprise-aliment').selectedIndex = 0;
        }
      }
      if (filtreReset == 'poursuivant') {
        this.filtres.poursuivant = 'all';
        document.getElementById('filtre_par_poursuivant').value = 'all';
      }
      if (filtreReset == 'typeCondChoix') {
        if (document.getElementById('type_entreprise-aliment')) {
          document.getElementById('type_entreprise-aliment').value = 'all';
        }
        if (document.getElementById('type_entreprise-animal')) {
          document.getElementById('type_entreprise-animal').value = 'all';
        }
      }
    },
  },
  created() {
    //Va chercher le type de condamnation dans url
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const type = urlParams.get('type');
    if (type == null) {
      this.type_condamnation = 'alimentation';
    } else {
      this.type_condamnation = type;
      this.filtres.typeCondChoix = type;
    }

    // On met isFetching à true pour afficher le loading dans la page
    this.isFetching = true;
    // Fetching all the data
    fetch(
      'https://www.donneesquebec.ca/recherche/api/3/action/datastore_search?limit=10000&resource_id=40105615-3abf-414b-bcba-182e8f2c5eb2&sort=Date_jugement desc'
    )
      .then((res) => res.json())
      .then((data) => {
        //Affiche tous les résultats

        this.ToutesLesCondamnation = data.result.records.filter(
          (r) =>
            r.SOC_CD_LOI != 'B-3.1' &&
            r.Type_etablissement != 'BIEN-ETRE ANIMAL' &&
            r.SOC_CD_LOI != 'P-42'
        ); // Alimentation
        this.ToutesLesCondamnationAnimal = data.result.records.filter(
          (r) => r.SOC_CD_LOI == 'B-3.1' || r.SOC_CD_LOI == 'P-42'
        ); // Animal

        switch (this.type_condamnation) {
          case 'animal':
            this.condamnations = data.result.records.filter(
              (r) => r.SOC_CD_LOI == 'B-3.1' || r.SOC_CD_LOI == 'P-42'
            ); // Animal
            break;
          case 'alimentation':
            this.condamnations = data.result.records.filter(
              (r) =>
                r.SOC_CD_LOI != 'B-3.1' &&
                r.Type_etablissement != 'BIEN-ETRE ANIMAL' &&
                r.SOC_CD_LOI != 'P-42'
            ); // Alimentation
            break;
        }

        // Caculate the number of pages
        this.nbrPages = Math.ceil(this.condamnations.length / 10);

        // Calculons le nombre de résultats dans la dernière page
        this.calculerNbrResultatsDernierePage();

        // On met isFetching à false pour retirer le loading dans la page
        this.isFetching = false;
      });
  },
};
</script>

<style></style>
